import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { TaskState } from '~/state/atoms/jobAtoms';

/**
 * Transforms a task into GenerationModelDetails format for processCreatedFiles
 * @param task - The task state containing model information
 * @returns GenerationModelDetails object with proper fallback values
 */
export function transformTaskToGenerationModel(
    task?: TaskState
): GenerationModelDetails | undefined {
    if (!task?.model) {
        return undefined;
    }

    return {
        name: task.model.name,
        label: task.model.label,
        version: task.model.version,
        isLatest: task.model.isLatest,
    };
}
